// src/data/caseStudies.ts
export const caseStudies = [
  {
    videoSrc: "/video/Knowledger_02.mp4",
    thumbnailSrc: "/Thumbnails/Knowledger.png",
    company: "Knowledger",
    description:
      "Deployed full-funnel execution across organic, paid, and community channels to redefine the traditional LMS.",
    tags: ["Design & Development-as-a-Service", "Branding", "UX/UI", "Frontend & Backend", "Smart Contracts", "AI Integration"],
    logoSrc: "/test-images/Knowledgerlogo.svg",
    path: "/case-study/knowledger",
    category: "Design & Development-as-a-Service",
    alt: "Knowledger",
    country: "INDIA",

  },
  {
    videoSrc: "/video/MoogleLabs_02.mp4",
    thumbnailSrc: "/Thumbnails/Mooglelabs.png",
    company: "MoogleLabs",
    description:
      "Executed a full-funnel roadmap across multiple phases, embedding performance-driven optimization into the brand’s growth journey.",
    tags: ["Growth-as-a-Service", "Design & Development", "Branding", "SEO", "Analytics", "Performance Marketing"],
    logoSrc: "/test-images/mooglelabs.svg",
    path: "/case-study/mooglelabs",
    category: "Growth-as-a-Service",
    alt: "MoogleLabs",
    country: "INDIA",

  },
  {
    videoSrc: "/video/Dublin_04.mp4",
    thumbnailSrc: "/Thumbnails/Dublin.png",
    company: "Dublin Technology Center",
    description:
      "Executed a full-funnel growth plan, activating high-impact workflows across product development strategies to accelerate demand & scale acquisitions.",
    tags: ["Growth-as-a-Service", "Web Design & Development", "SEO", "Paid Ads", "Content Marketing", "Automation", "Google My Business"],
    logoSrc: "/test-images/dublin.svg",
    path: "/case-study/dublin-technology-center-workspaces",
    category: "Growth-as-a-Service",
    alt: "Dublin Technology Center",
    country: "USA",

  },

  {
    videoSrc: "/video/SkyHi.mp4",
    thumbnailSrc: "/Thumbnails/Skyhi.png",
    company: "SkyHi Tech Academy",
    description:
      "Executed a growth plan with a full website redesign, focused digital transformation strategies to enhance digital footprint & steady growth.",
    tags: ["Growth-as-a-Service", "Web Design & Development", "SEO", "Paid Ads", "Automation", "Content Strategy", "Social Media"],
    logoSrc: "/test-images/sky-hi.svg",
    path: "/case-study/skyhi-tech-academy",
    category: "Growth-as-a-Service",
    alt: "SkyHi Tech Academy",
    country: "USA",

  },
  {
    videoSrc: "/video/ElderLaw.mp4",
    thumbnailSrc: "/Thumbnails/ElderLaw.png",
    company: "Elder Law",
    description:
      "Functioned as an embedded growth team. The approach was about building authority, relevance, and long-term equity in search.",
    tags: ["Growth-as-a-Service", "Web", "SEO", "Paid", "Content"],
    logoSrc: "/test-images/elder-law.svg",
    path: "/case-study/elder-law-center-of-wisconsin",
    category: "Growth-as-a-Service",
    alt: "Elder Law",
    country: "india",

  },
  {
    videoSrc: "/video/SeasiaInfotech_03.mp4",
    thumbnailSrc: "/Thumbnails/Seasia.png",
    company: "Seasia",
    description:
      "Created a unified growth framework that helped drive consistent, high-quality leads across markets.",
    tags: ["Growth-as-a-Service", "Design/Development", "SEO"],
    logoSrc: "/test-images/seasia-logo.png",
    path: "/case-study/seasia-infotech",
    category: "Growth-as-a-Service",
    alt: "Seasia",
    country: "india",

  },
  {
    videoSrc: "/video/CereKart_02.mp4",
    thumbnailSrc: "/Thumbnails/CereKart.png",
    company: "CereKart",
    description:
      "Applied Design & Development-as-a-Service, blending brand identity, UX/UI, and backend solutions to fast-track concept-to-app launch with prototyping and feedback.",
    tags: ["Design & Development-as-a-Service", "Branding", "design", "UI/UX", "Mobile", "Web", "Frontend", "Backend", "CMS"],
    logoSrc: "/test-images/cere-kart.svg",
    path: "/case-study/cerekart",
    category: "Design & Development-as-a-Service",
    alt: "CereKart",
    country: "india",

  },
  {
    videoSrc: "/video/CereRide_02.mp4",
    thumbnailSrc: "/Thumbnails/CereRides.png",
    company: "CereRides",
    description:
      "The approach blended a bold visual identity, frictionless interactions, and future-proof backend architecture to deliver a robust product.",
    tags: ["Design & Development-as-a-Service", "Branding", "Mobile-first UX/UI", "Frontend & Backend"],
    logoSrc: "/test-images/cere-rides.svg",
    path: "/case-study/cererides",
    category: "Design & Development-as-a-Service",
    alt: "CereRides",
    country: "india",

  },

  {
    videoSrc: "/video/Mainstreet.mp4",
    thumbnailSrc: "/Thumbnails/Mainstreet.png",
    company: "Mainstreet Equity Corp",
    description:
      "Built a Growth-as-a-Service model integrating full-stack design, development, and marketing. Leveraging iterative sprints and analytics for smarter, faster growth.",
    tags: ["Growth-as-a-Service", "Design/Development", "PPC"],
    logoSrc: "/logo/MainstreetLogo.svg",
    path: "/case-study/mainstreet",
    category: "Growth-as-a-Service",
    alt: "Mainstreet Equity Corp",
    country: "USA",

  },

  {
    videoSrc: "/video/Teacher_Cool.mp4",
    thumbnailSrc: "/Thumbnails/TeacherCool.png",
    company: "Teacher Cool",
    description:
      "Applied our Design & Development-as-a-Service model for Teacher Cool's platform, aligning branding, UX/UI, and full-stack development.",
    tags: ["Design & Development-as-a-Service", "Branding", "UX/UI Design", "Frontend & Backend", "Dashboards", "Payments"],
    logoSrc: "/test-images/teacher-cool-logo.png",
    path: "/case-study/teacher-cool",
    category: "Design & Development-as-a-Service",
    alt: "Teacher Cool",
    country: "india",

  },
  {
    videoSrc: "/video/Kensington.mp4",
    thumbnailSrc: "/Thumbnails/Kensington.png",
    company: "Kensington",
    description:
      "Strengthened Kensington Labs’ online presence by rebuilding its website and aligning SEO and SMO efforts to improve discoverability, trust, and long-term brand authority in a competitive digital landscape.",
    tags: ["Growth-as-a-Service", "SEO", "SMO", "Web redesign & development"],
    logoSrc: "/logo/Kensington.svg",
    path: "/case-study/kensington",
    category: "Growth-as-a-Service",
    alt: "Kensington",
    country: "USA",

  },
  {
    videoSrc: "/video/Eyecon.mp4",
    thumbnailSrc: "/Thumbnails/Eyecon.png",
    company: "Eyecon",
    description:
      "Enhanced Eyecon’s app and brand performance by aligning ASO with high-impact creatives, deep analytics, and SEO-led distribution—driving stronger visibility, smarter optimization, and consistent user growth.",
    tags: ["Growth-as-a-Service", "ASO", "SEO", "SMO", "Creatives", "Analytics"],
    logoSrc: "/logo/eyecon.svg",
    path: "/case-study/eyecon",
    category: "Growth-as-a-Service",
    alt: "Eyecon",
    country: "india",

  },

  {
    videoSrc: "/video/HaraHeri.mp4",
    thumbnailSrc: "/Thumbnails/Haraheri.png",
    company: "HaraHeri",
    description:
      "Implemented a focused growth strategy to strengthen HaraHari’s digital presence, driving organic demand through SEO, Local SEO, and SMO while improving visibility, engagement, and customer acquisition.",
    tags: ["Growth-as-a-Service", "SEO", "Local SEO", "SMO"], category: "Growth-as-a-Service",
    logoSrc: "/logo/HaraHeri.svg",
    path: "/case-study/haraheri",
    alt: "HaraHeri",
    country: "india",

  },


  {
    videoSrc: "/video/UnitedBuildingSolution.mp4",
    thumbnailSrc: "/Thumbnails/ubs.png",
    company: "United Building Solutions",
    description:
      "Built a scalable paid acquisition framework for United Building Solution using Google Ads and performance marketing, streamlining campaign structure and targeting to support consistent demand across service-led markets.",
    tags: ["Growth-as-a-Service", "google ads", "Performance marketing"],
    category: "Growth-as-a-Service",
    logoSrc: "/logo/ubs.svg",
    path: "/case-study/united-building-solutions",
    country: "USA",
    alt: "United Building Solutions",
  },

  {
    videoSrc: "/video/CarsCentro.mp4",
    thumbnailSrc: "/Thumbnails/CarsCentro.png",
    company: "Cars Centro",
    description:
      "Reimagined Cars Centro’s digital presence with a bold new brand identity, user-centric UX/UI, and scalable tech stack to transform low-volume traffic into high-intent engagement and growth.",
    tags: ["Design & Development-as-a-Service", "Branding", "UX/UI", "Frontend & Backend", "Smart Contracts", "AI Integration"],
    category: "Design & Development-as-a-Service",
    logoSrc: "/logo/CarsCentro.svg",
    path: "/case-study/cars-centro",
    country: "india",
    alt: "Cars Centro",
  },


  {
    videoSrc: "/video/JemJem.mp4",
    thumbnailSrc: "/Thumbnails/JemJem.png",
    company: "JemJem",
    description:
      "From technical SEO challenges to market authority, MMB transformed Jem Jem into a recognized refurbished Apple brand through integrated SEO, content strategy, and trust-building initiatives.",
    tags: ["Digital Strategy", "Conversion Optimization", "Brand Awareness", "SEO ", "Growth-as-a-Service"],
    category: "Growth-as-a-Service",
    logoSrc: "/logo/JemJemLogo.svg",
    path: "/case-study/jemjem",
    country: "india",

    alt: "JemJem",
  },

  {
    videoSrc: "/video/RentalCar247.mp4",
    thumbnailSrc: "/Thumbnails/RentelCars247.png",
    company: "Rental Cars 24/7",
    description:
      "By combining intent-led SEO with high-efficiency PPC optimization, MMB helped Rental Cars 24/7 strengthen search visibility, improve conversion rates, and scale bookings profitably.",
    tags: ["PPC", "Branding", "SEO ", "Growth-as-a-Service"],
    category: "Growth-as-a-Service",
    logoSrc: "/logo/RentelCarsLogo.svg",
    path: "/case-study/rentalcars247",
    country: "india",

    alt: "Rental Cars 24/7",
  },

  {
    videoSrc: "/video/Showcase.mp4",
    thumbnailSrc: "/Thumbnails/ShowcaseLandscaping.png",
    company: "Showcase Landscaping",
    description:
      "Showcase Landscaping’s growth transformation demonstrates how MMB’s integrated SEO and PPC strategy turned zero digital visibility into a scalable lead-generation engine, driving 4X higher daily leads, lower acquisition costs, and measurable business growth.",
    tags: [
      "Growth-as-a-Service",
      "SEO",
      "PPC",
      "Lead Generation",
      "Digital Strategy",
    ],
    category: "Growth-as-a-Service",
    logoSrc: "/logo/ShowcaseLandscapingLogo.svg",
    path: "/case-study/showcase-landscaping",
    alt: "Showcase Landscaping",
    country: "USA",

  },

  {
    videoSrc: "/video/Cerebrum.mp4",
    thumbnailSrc: "/Thumbnails/Cerebrum.png",
    company: "Cerebrum Infotech",
    description:
      "Cerebrum Infotech’s journey reflects how strategic digital infrastructure - powered by strategic branding, web development, and performance-led SEO - can create sustainable visibility, trust, and scalable growth.",
    tags: [
      "Design & Development-as-a-Service",
      "Branding",
      "Web Design & Development",
      "SEO",
    ],
    category: "Design & Development-as-a-Service",
    logoSrc: "/logo/CerebrumLogo.svg",
    path: "/case-study/cerebrum-infotech",
    alt: "Cerebrum Infotech",
    country: "india",

  },

  {
    videoSrc: "/video/Realesta.mp4",
    thumbnailSrc: "/Thumbnails/Realesta.png",
    company: "Realesta",
    description:
      "Realesta’s journey reflects how strategic digital infrastructure - powered by strategic branding, web development, and performance-led SEO - can create sustainable visibility, trust, and scalable growth.",
    tags: ["Design & Development-as-a-Service", "Branding", "Web Design & Development", "SEO"],
    category: "Design & Development-as-a-Service",
    logoSrc: "/logo/RealEsta.svg",
    path: "/case-study/realesta",
    alt: "Realesta",
    country: "india",

  },


 
  {
    videoSrc: "/video/BoardGames.mp4",
    thumbnailSrc: "/Thumbnails/BoardGames.png",
    company: "BoardGamesNMore",
    description:
      "From a small organic footprint to sustained eCommerce growth, BoardGamesNMore scaled customer acquisition through SEO, content marketing, local search, analytics, and paid social campaigns.",
    tags: [
      "SEO",
      "Local SEO",
      "Technical SEO",
      "Content Marketing",
      "Facebook Advertising",
      "Analytics",
      "Growth-as-a-Service",
      "Performance Marketing",
    ],
    category: "Growth-as-a-Service",
    logoSrc: "/logo/BoardGames.svg",
    path: "/case-study/boardgamesnmore",
    country: "india",
    alt: "BoardGamesNMore",
  },
  {
    videoSrc: "/video/SmartDelievery.mp4",
    thumbnailSrc: "/Thumbnails/SmartDelivery.png",
    company: "Smart Delivery",
    description:
      "Smart Delivery evolved from limited online visibility to a stronger organic growth engine through integrated SEO, local search optimization, and authority-building initiatives.",
    tags: [
      "SEO",
      "Local SEO",
      "Technical SEO",
      "Link Building",
      "Social Media Optomization",

    ],
    category: "Growth-as-a-Service",
    logoSrc: "/logo/SmartDelivery.svg",
    path: "/case-study/smart-delivery",
    country: "india",
    alt: "Smart Delivery",
  },
  {
    videoSrc: "/video/ChocolateFactory.mp4",
    thumbnailSrc: "/Thumbnails/ChocolateFactoryThailand.png",
    company: "The Chocolate Factory Thailand",
    description:
      "When the pandemic shifted customer behavior online, The Chocolate Factory Thailand leveraged MMB services to turn social channels into a powerful sales engine through content-led engagement and conversational commerce.",
    tags: [
      "Social Media Marketing",
      "Social Commerce",
      "Content Strategy",
      "Customer Engagement",
      "Conversational Commerce",
    ],
    category: "Growth-as-a-Service",
    logoSrc: "/logo/ChoclateFactoryThailand.png",
    path: "/case-study/chocolate-factory-thailand",
    country: "india",
    alt: "Chocolate-Factory-Thailand",
  },
  {
    videoSrc: "/video/",
    thumbnailSrc: "/Thumbnails/OhMyPrintSolutions.png",
    company: "Oh My Print Solutions",
    description:
      "By rebuilding a fragmented Google Ads account around search intent and conversion efficiency, Oh My Print Solutions generated stronger leads while lowering acquisition costs.",
      tags: [
        "Google Ads",
        "PPC Management",
        "Performance Marketing",
        "Conversion Rate Optimization",
        "Remarketing",
        "Conversion Tracking",
      ],
    category: "Growth-as-a-Service",
    logoSrc: "/logo/OhMyPrintSolutions.svg",
    path: "/case-study/oh-my-print-solutions",
    country: "india",
    alt: "Oh My Print Solutions",
  },
  {
    videoSrc: "/video/ParkNFly.mp4",
    thumbnailSrc: "/Thumbnails/ParkNFly.png",
    company: "Park n Fly",
    description:
      "Park n Fly uncovered new growth opportunities by optimizing its Google Ads ecosystem, improving conversion intelligence, campaign efficiency, and booking performance at scale.",
      tags: [
        "Google Ads",
        "Google Analytics",
        "PPC Management",
        "Conversion Optimization",
        "Conversion Tracking",
        "Performance Marketing",
      ],
    category: "Growth-as-a-Service",
    logoSrc: "/logo/ParkNFly.svg",
    path: "/case-study/parknfly",
    country: "india",
    alt: "Park n Fly",
  },
  {
    videoSrc: "/video/PrecisePortion.mp4",
    thumbnailSrc: "/Thumbnails/PrecisePortions.png",
    company: "Precise Portions",
    description:
      "From nutrition education to an engaged online community, Precise Portions strengthened its digital presence through educational content, social media strategy, and community-first engagement.",
      tags: [
        "Social Media Marketing ",
        "Organic Growth ",
        "Community Building ",
        "Content Strategy ",
        "Brand Awareness ",
      ],
    category: "Growth-as-a-Service",
    logoSrc: "/logo/PrecisePortions.svg",
    path: "/case-study/precise-portions",
    country: "india",
    alt: "Oh My Print Solutions",
  },
  {
    videoSrc: "/video/Varsany.mp4",
    thumbnailSrc: "/Thumbnails/Varsany.png",
    company: "Varsany",
    description:
      "Varsany partnered with us to strengthen its search presence across key fashion categories and compete more effectively with larger players. Through technical SEO and intent-driven content, the brand improved category visibility, organic discovery, and commercial performance.",
      tags: [
        "SEO & Content",
      ],
    category: "Growth-as-a-Service",
    logoSrc: "/logo/VarsanyLogo.svg",
    path: "/case-study/varsany",
    country: "USA",
    alt: "Varsany",
  },
  {
    videoSrc: "/video/NamasteHomes.mp4",
    thumbnailSrc: "/Thumbnails/NamasteyHomes.png",
    company: "Namastey Homes",
    description:
      "Namastey Homes needed a unified digital presence across websites, OTAs, WhatsApp, and social media to keep property information current and support bookings. We managed the full ecosystem, creating a more consistent and connected property discovery experience.",
      tags: [
        "OTA Listing Management",
        "Content Marketing",
        "WhatsApp Marketing",
      ],
    category: "Growth-as-a-Service",
    logoSrc: "/logo/NamasteyHomes.svg",
    path: "/case-study/namastey-homes",
    country: "india",
    alt: "Namastey Homes",
  },
];
